const supported = [
  'de-DE',
  'en-GB',
  'fr-FR',
  'en-US',
  'it-IT',
  'es-ES',
  'pt-BR'
];

const defaultLocale = 'en-US';

export function defaultOptions() {
  if (Intl && Intl.DateTimeFormat) {
    const {timeZone, locale} = new Intl.DateTimeFormat().resolvedOptions();
    return {
      timezone: timeZone,
      locale: supported[locale] || defaultLocale
    };
  }
  return {
    timezone: 'Etc/UTC',
    locale: defaultLocale
  };
}
